import {ChatbotAvailableProfile} from './chatbot-available-profile';
import {TestVariation} from '../../test/state/test-variation';

export class ChatbotProfile {

  private _keycloakId: string;
  private _status: string;
  private _acronym: string;
  private _firstName: string;
  private _lastName: string;
  private _variation: number;

  constructor(keycloakId: string,
              status: string,
              acronym: string,
              firstName: string,
              lastName: string,
              variation: number) {
    this._keycloakId = keycloakId;
    this._status = status;
    this._acronym = acronym;
    this._firstName = firstName;
    this._lastName = lastName;
    this._variation = variation;
  }

  get keycloakId(): string {
    return this._keycloakId;
  }

  get status(): string {
    return this._status;
  }

  set status(value: string) {
    this._status = value;
  }

  get acronym(): string {
    return this._acronym;
  }

  get firstName(): string {
    return this._firstName;
  }

  get lastName(): string {
    return this._lastName;
  }

  get variation(): number {
    return this._variation;
  }

  static buildFrom(chatbotAvailableProfile: ChatbotAvailableProfile, variation: number){
    return new ChatbotProfile(
      chatbotAvailableProfile.keycloakId,
      'ACTIVE',
      this.generateAcronym(chatbotAvailableProfile),
      chatbotAvailableProfile.firstName,
      chatbotAvailableProfile.lastName,
      variation
    );
  }

  static buildFromList(chatbotProfileRepresentations: ChatbotProfileRepresentation[],
                       chatbotUserRepresentations: ChatbotUserRepresentation[]){
    return chatbotProfileRepresentations.map(
      profileRepresentation => {
        const matchingUserRepresentation = chatbotUserRepresentations.find(
          userRepresentation => userRepresentation.keycloakId === profileRepresentation.user_id
        );

        if (!matchingUserRepresentation) {
          return null;
        }

        return new ChatbotProfile(
          profileRepresentation.user_id,
          profileRepresentation.status,
          profileRepresentation.acronym,
          matchingUserRepresentation.firstName,
          matchingUserRepresentation.lastName,
          matchingUserRepresentation.variation.motiveCount
        );
      }
    );
  }

  static generateAcronym(profile: ChatbotAvailableProfile): string{
    return profile.keycloakId.slice(0, 6);
  }
}

export class ChatbotProfileRepresentation {
  public acronym: string;
  public chat_id: number;
  public profile_id: number;
  public status: string;
  public user_id: string;
}

export class ChatbotUserRepresentation {
  public firstName: string;
  public keycloakId: string;
  public lastName: string;
  public variation?: TestVariation;
}
